import { Box, useLayoutContext } from "arkh";
import React, { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { FileCollectionItemRelay } from "../../../components/FileCollection";
import { DescriptionContentFiles_files$key } from "./__generated__/DescriptionContentFiles_files.graphql";
import { useOpenFile } from "../../Files/useOpenFile";

export function DescriptionContentFiles(props: {
  files: DescriptionContentFiles_files$key;
  hideOrg?: boolean;
}) {
  const files = useFragment(
    graphql`
      fragment DescriptionContentFiles_files on File @relay(plural: true) {
        id
        url
        id
        ...FileCollectionItem_File
      }
    `,
    props.files
  );
  const openFile = useOpenFile();
  const showFiles = useMemo(() => files.length > 0, [files.length]);
  const layout = useLayoutContext();
  return showFiles ? (
    <Box
      spaceHorizontal="medium"
      spaceBottom="small"
      style={{
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center",
        marginRight: -layout.space.xsmall,
        marginBottom: -layout.space.xsmall,
      }}
    >
      {files.map((file) => (
        <Box spaceHorizontal="xsmall" key={file.id}>
          <FileCollectionItemRelay
            hideOrg={props.hideOrg}
            file={file}
            onShowFile={(f) =>
              openFile({
                url: f.url,
                fileId: f.id,
                fileName: f.name ?? "",
                fileType: f.type,
              })
            }
            key={file.id}
          />
        </Box>
      ))}
    </Box>
  ) : null;
}
